import { render, staticRenderFns } from "./AgreementConflictsList.vue?vue&type=template&id=179441b6&"
import script from "./AgreementConflictsList.vue?vue&type=script&lang=js&"
export * from "./AgreementConflictsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports